var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Delete as DeleteIcon } from '@mui/icons-material';
import { Box, Button, Tooltip } from '@mui/material';
import { Fragment, useCallback, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GasSufficiencyMessage } from '../../components/GasSufficiencyMessage';
import { Step } from '../../components/Step';
import { StepDivider } from '../../components/StepDivider';
import { SwapButton } from '../../components/SwapButton';
import { useNavigateBack, useRouteExecution } from '../../hooks';
import { SwapFormKey } from '../../providers';
import { RouteExecutionStatus } from '../../stores';
import { StatusBottomSheet } from './StatusBottomSheet';
import { Container } from './SwapPage.style';
import { getTokenValueLossThreshold, TokenValueBottomSheet, } from './TokenValueBottomSheet';
export const SwapPage = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const { navigateBack } = useNavigateBack();
    const tokenValueBottomSheetRef = useRef(null);
    const { setValue } = useFormContext();
    const { route, status, executeRoute, restartRoute, deleteRoute } = useRouteExecution(state === null || state === void 0 ? void 0 : state.routeId);
    const handleExecuteRoute = useCallback(() => {
        var _a, _b;
        if ((_a = tokenValueBottomSheetRef.current) === null || _a === void 0 ? void 0 : _a.isOpen()) {
            (_b = tokenValueBottomSheetRef.current) === null || _b === void 0 ? void 0 : _b.close();
        }
        executeRoute();
        setValue(SwapFormKey.FromAmount, '');
    }, [executeRoute, setValue]);
    const handleSwapClick = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (status === RouteExecutionStatus.Idle) {
            const thresholdExceeded = getTokenValueLossThreshold(route);
            if (thresholdExceeded) {
                (_a = tokenValueBottomSheetRef.current) === null || _a === void 0 ? void 0 : _a.open();
            }
            else {
                handleExecuteRoute();
            }
        }
        if (status === RouteExecutionStatus.Failed) {
            restartRoute();
        }
    });
    const handleRemoveRoute = () => {
        navigateBack();
        deleteRoute();
    };
    const getSwapButtonText = () => {
        switch (status) {
            case RouteExecutionStatus.Idle:
                return t('button.startSwap');
            case RouteExecutionStatus.Failed:
                return t('button.restartSwap');
            default:
                return '';
        }
    };
    return (_jsxs(Container, { children: [route === null || route === void 0 ? void 0 : route.steps.map((step, index, steps) => {
                var _a, _b, _c, _d, _e;
                const fromToken = index === 0
                    ? Object.assign(Object.assign({}, step.action.fromToken), { amount: step.action.fromAmount }) : undefined;
                const toToken = index === steps.length - 1
                    ? Object.assign(Object.assign({}, ((_b = (_a = step.execution) === null || _a === void 0 ? void 0 : _a.toToken) !== null && _b !== void 0 ? _b : (_c = step.action) === null || _c === void 0 ? void 0 : _c.toToken)), { amount: (_e = (_d = step.execution) === null || _d === void 0 ? void 0 : _d.toAmount) !== null && _e !== void 0 ? _e : step.estimate.toAmount }) : undefined;
                return (_jsxs(Fragment, { children: [_jsx(Step, { step: step, fromToken: fromToken, toToken: toToken }), steps.length > 1 && index !== steps.length - 1 ? (_jsx(StepDivider, {})) : null] }, step.id));
            }), status === RouteExecutionStatus.Idle ||
                status === RouteExecutionStatus.Failed ? (_jsxs(_Fragment, { children: [_jsx(GasSufficiencyMessage, { route: route, mt: 2 }), _jsxs(Box, Object.assign({ mt: 2, display: "flex" }, { children: [_jsx(SwapButton, { text: getSwapButtonText(), onClick: handleSwapClick, currentRoute: route, 
                                // disable={status === 'idle' && (isValidating || !isValid)}
                                enableLoading: true }), status === RouteExecutionStatus.Failed ? (_jsx(Tooltip, Object.assign({ title: t('button.removeSwap'), placement: "bottom-end", enterDelay: 400, arrow: true }, { children: _jsx(Button, Object.assign({ onClick: handleRemoveRoute, sx: {
                                        minWidth: 48,
                                        marginLeft: 1,
                                    } }, { children: _jsx(DeleteIcon, {}) })) }))) : null] }))] })) : null, route && status ? (_jsx(StatusBottomSheet, { status: status, route: route })) : null, route ? (_jsx(TokenValueBottomSheet, { route: route, ref: tokenValueBottomSheetRef, onContinue: handleExecuteRoute })) : null] }));
};
